import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environment';
import {
  BulkCreatePayload,
  BulkCreateResponse,
} from '@modules/courses/components/guided-course-creation-dialog/guided-course-creation.constants';

@Injectable({ providedIn: 'root' })
export class H5pContentService {
  private readonly http = inject(HttpClient);

  bulkCreate(payload: BulkCreatePayload): Observable<BulkCreateResponse> {
    return this.http.post<BulkCreateResponse>(
      `${environment.h5pBaseUrl}/bulk-create`,
      payload,
    );
  }
}
